module.exports = __webpack_public_path__ + "ring.wav?180297e829c7fdb22416d9e792f87d3d";


//////////////////
// WEBPACK FOOTER
// ./src/assets/ring.wav
// module id = 19
// module chunks = 0